import { create } from "zustand"

interface OnboardModal {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

const useOnboardModal = create<OnboardModal>((set) => ({
  isOpen: true,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useOnboardModal
